// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import * as React from 'react';
import useDeviceWidth from '../../hooks/deviceWidth';
import { type VideoContent, VideoPlayer } from '../Video/VideoPlayer';
import useStyles from './VideoGrid.styles';

interface VideoGridProps {
  videos: VideoContent[];
}

/**
 * @deprecated V2 component
 */
export function VideoGrid({ videos }: VideoGridProps) {
  const { isLarge } = useDeviceWidth();
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      {isLarge && (
        <div>
          <div>
            <VideoPlayer
              content={videos[0]}
              containerStyle={classes.largeVideoContainer}
            />
            <h3 className={classes.titleLarge}>{videos[0].fields.title}</h3>
          </div>
        </div>
      )}
      {!isLarge && (
        <div className={classes.learnMore}>
          {/** biome-ignore lint/performance/noImgElement: Automated migration to Biome */}
          <img
            src='/cmsAssets/assets/img/icons/CircleDownArrowOutline.png'
            alt='learn more'
          />
          <p className={classes.learnMoreText}>Learn More</p>
        </div>
      )}
      <div className={classes.videoGroup}>
        {videos.slice(isLarge ? 1 : 0).map((video) => (
          <div className={classes.smallVideo} key={video.sys.id}>
            <VideoPlayer
              content={video}
              containerStyle={classes.smallVideoContainer}
              smallIcon
            />
            <h4 className={classes.titleSmall}>{video.fields.title}</h4>
          </div>
        ))}
      </div>
    </div>
  );
}
